import React, { FunctionComponent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../store";
import { getDataPeriodSchools, getFullEvidenceInDataPeriods, hideEquityBenchmarksModal } from "../../../../../../store/onboarding/actions";
import { Modal, ModalProps } from "react-bootstrap";
import EquityBenchmarksModalContent from "./EquityBenchmarksModalContent";
import LoadingIndicator from "../../../../../common/onboarding/LoadingIndicator";
import { EvidencePeriodData } from "../../../../../../store/onboarding/types";
import useDeviceDetect from "../../../../../../utils/hooks/useDeviceDetect";

type OwnProps = {};

type Props = OwnProps;

const EquityBenchmarksModal: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch();
  const isDesktop = useDeviceDetect();
  const showModal = useSelector(
    (s: ApplicationState) => s.onboarding.modalsState.showEquityBenchmarksModal
  );
  const currentDataPeriod = useSelector((s: ApplicationState) => s.onboarding.currentDataPeriod);

  useEffect(() => {
    if(showModal) {
      dispatch(getDataPeriodSchools(currentDataPeriod?.id))
      dispatch(getFullEvidenceInDataPeriods(currentDataPeriod?.id))
    }
  },[showModal])

  let { getFullEvidenceInDataPeriod } = useSelector((s: ApplicationState) => s.onboarding.isLoading);
  const fullEvidenceInDataPeriod = useSelector<
      ApplicationState,
      EvidencePeriodData | undefined
    >((s) => s.onboarding.fullEvidenceInDataPeriod);

  const handleHide = () => {
    dispatch(hideEquityBenchmarksModal());
  };

  useEffect(() => {
    if(showModal) {
      let modalElement:HTMLElement = document.getElementById('benchmark-modal')!;
      modalElement?.parentElement!.classList?.add('benchmark-modal-pdf-class');
    } else {
      let modalElement:HTMLElement = document.getElementById('benchmark-modal')!;
      modalElement?.parentElement!.classList?.remove('benchmark-modal-pdf-class');
    }
  },[showModal])

  return (
    <Modal
      show={showModal}
      onHide={handleHide}
      animation={false}
      size={isDesktop ? "xl" : "lg"}
      backdropClassName="customDarkModalBackdrop in"
      id="benchmark-modal"
      className="equity-benchmarks-modal"
      centered
    >
      <Modal.Header closeButton className="purpleModalHeader">
        <Modal.Title>Equity Benchmarks ({currentDataPeriod?.name})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { showModal 
          ? getFullEvidenceInDataPeriod 
              ? <LoadingIndicator type="benchmarks-table" columns={6} />
              : fullEvidenceInDataPeriod?.pagination?.total_row_count 
                ? <EquityBenchmarksModalContent dataPeriod={currentDataPeriod}/>
                : ''
          : '' 
        }
      </Modal.Body>
    </Modal>
  );
};

export default EquityBenchmarksModal;
